<template>
  <component :is="modalToShow" v-if="modalToShow" v-model="showModal" />
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import RtsModal from "@/views/customer/imbp/modals/RtsModal.vue"
  import ComplaintsModal from "@/views/customer/complaints/modals/ComplaintsModal.vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import { RouteNames } from "@/types/router"

  export default defineComponent({
    components: { RtsModal, ComplaintsModal },
    data() {
      return {
        current: useCurrentAccountStore(),
        complaintsRouteName: RouteNames.CustomerComplaints,
        imbpRouteName: RouteNames.CustomerImbp,
        showModal: true,
      }
    },
    computed: {
      modals() {
        return [
          {
            component: ComplaintsModal,
            show:
              !!this.current.hasOpenComplaint.data &&
              !this.current.seenOpenComplaints &&
              this.$route.name !== this.complaintsRouteName,
          },
          {
            component: RtsModal,
            show:
              this.current.rtsMeters.data.hasRtsMeters &&
              !this.current.rtsMeters.data.hasUpcomingMeterExchange &&
              !this.current.seenRtsMeterModal &&
              !this.$route.path.includes("/imbp"),
          },
        ]
      },
      modalToShow() {
        return this.modals.find((modal) => modal.show)?.component
      },
    },
  })
</script>
